module.exports = __webpack_public_path__ + "static/media/my-cart-black.19b8f94c.svg";